import React from 'react';
import { Card, CardProps } from '../../../../../CommonComponents/OPL/Card/Card';

export const StepCard: React.FC<CardProps> = props => {
  return <Card maxWidth="712px" p="32" mx="auto" {...props} />;
};
